import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import *  as moment from 'moment';
import { Moment } from 'moment';
import { ToastrService } from 'ngx-toastr';
import { ApiService } from '../../../../services/api/api.service';

@Component({
  selector: 'app-mfcustom-input-popup',
  templateUrl: './mfcustom-input-popup.component.html',
  styleUrls: ['./mfcustom-input-popup.component.css']
})
export class MFCustomInputPopupComponent implements OnInit {
  public value: any;
  public loading: boolean;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private dialogRef?: MatDialogRef<MFCustomInputPopupComponent>, private messageService?: ToastrService, private apiService?: ApiService) {

  }

  ngOnInit() {
  }

  public save() {
    if (!this.value || this.value == "") {
      this.messageService.error("Please specify Value", "Required");
    }
    else {

      this.loading = true;
      this.apiService.post('/api/lookupValue/createOther/' + this.data.lookupValueGroupId, { name: this.value })
        .subscribe(o => {
          this.loading = true;
          this.dialogRef.close(o);
        }, err => {

          this.loading = false;
          this.messageService.error("Failed to add other value", "Failed");
        })
    }
  }
  public close() {

    this.dialogRef.close();
  }

}
